const RX_SCOPE = 'pg-prescription';
const PD_SCOPE = 'pg-pupillary-distance';
const PRESCRIPTION_STEP_FORM_ERROR_ID = 'prescription-step-form-error';
const PRESCRIPTION_STEP_UPLOAD_ERROR_ID = 'prescription-step-upload-error';
const PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID = 'prescription-step-upload-description';
const EXISTING_CUSTOMER = 'ExistingCustomer';
const NEW_PRESCRIPTION = 'NewPrescription';
const NEW_PRESCRIPTION_AND_UPLOAD = 'NewPrescriptionAndUpload';
const PRESCRIPTION_FILE = 'PrescriptionFile';
const EMAIL_PRESCRIPTION = 'EmailPrescription';

export { EMAIL_PRESCRIPTION, EXISTING_CUSTOMER, NEW_PRESCRIPTION, NEW_PRESCRIPTION_AND_UPLOAD, PD_SCOPE, PRESCRIPTION_FILE, PRESCRIPTION_STEP_FORM_ERROR_ID, PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID, PRESCRIPTION_STEP_UPLOAD_ERROR_ID, RX_SCOPE };
//# sourceMappingURL=constants.js.map
